var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreditionBoldControl(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69,32.35V3.68H0V0H15.39a17.79,17.79,0,0,1,5.55.76,10.11,10.11,0,0,1,3.67,2.07,7.53,7.53,0,0,1,2,3,9.93,9.93,0,0,1,.62,3.45,8.25,8.25,0,0,1-3.07,6.61,8.64,8.64,0,0,1-2,1.2,10.9,10.9,0,0,1,2.71,1.29,9.61,9.61,0,0,1,2.15,2A8.79,8.79,0,0,1,29,26a10.68,10.68,0,0,1-.58,3.38,8.08,8.08,0,0,1-2.13,3.25A11.56,11.56,0,0,1,22,35a21.14,21.14,0,0,1-7,1H0V32.35Zm10.22-17a10.23,10.23,0,0,0,3.36-.47,6,6,0,0,0,2.2-1.26,4.59,4.59,0,0,0,1.2-1.84A6.88,6.88,0,0,0,22,9.55a6.87,6.87,0,0,0-.43-2.49,4.45,4.45,0,0,0-1.36-1.85,6.83,6.83,0,0,0-2.44-1.14,14.75,14.75,0,0,0-3.66-.39H9.75V15.36Zm-5.16,17H15a14.36,14.36,0,0,0,4.06-.49,7.28,7.28,0,0,0,2.7-1.35,5.08,5.08,0,0,0,1.48-2.11,7.85,7.85,0,0,0,.46-2.77,6.64,6.64,0,0,0-.42-2.34,5,5,0,0,0-1.41-2,7.41,7.41,0,0,0-2.63-1.39,13.49,13.49,0,0,0-4.05-.53H9.75Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreditionBoldControl);
export default __webpack_public_path__ + "static/media/tredition-bold-control.8293f3084db256db01090d3e8da0aa58.svg";
export { ForwardRef as ReactComponent };